"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

exports.__esModule = true;
exports.MULTICALL_NETWORKS = exports.NODE_API = exports.MULTICALL_ABI = void 0;

var web3_1 = __importDefault(require("web3"));

var Multicall_json_1 = __importDefault(require("../abis/Multicall.json"));

exports.MULTICALL_ABI = Multicall_json_1["default"];

var addresses_1 = __importDefault(require("./addresses"));

var NODE_API = {
  testnet: 'https://nodeapi.test.energi.network',
  mainnet: 'https://nodeapi.energi.network'
};
exports.NODE_API = NODE_API;
var MULTICALL_NETWORKS = {
  testnet: '0x9802d5160660622642a24beE9EF6625ed4Ad0838',
  mainnet: '0x0c44695d3F94e3027966E273c7E09bD481098781'
};
exports.MULTICALL_NETWORKS = MULTICALL_NETWORKS;

var getTokens = function getTokens(network) {
  return __awaiter(void 0, void 0, void 0, function () {
    var web3, multicall, nameMethod, symbolMethod, decimalsMethod, nameCalls, symbolCalls, decimalsCalls, callResult, _a, encodedNames, encodedSymbols, encodedDecimals, names, symbols, decimals, chainId;

    return __generator(this, function (_b) {
      switch (_b.label) {
        case 0:
          web3 = new web3_1["default"](NODE_API[network]);
          return [4
          /*yield*/
          , new web3.eth.Contract(Multicall_json_1["default"], MULTICALL_NETWORKS[network])];

        case 1:
          multicall = _b.sent();
          nameMethod = web3.eth.abi.encodeFunctionSignature('name()');
          symbolMethod = web3.eth.abi.encodeFunctionSignature('symbol()');
          decimalsMethod = web3.eth.abi.encodeFunctionSignature('decimals()');
          nameCalls = [];
          symbolCalls = [];
          decimalsCalls = [];
          addresses_1["default"][network].forEach(function (address) {
            nameCalls.push({
              target: address,
              callData: nameMethod
            });
            symbolCalls.push({
              target: address,
              callData: symbolMethod
            });
            decimalsCalls.push({
              target: address,
              callData: decimalsMethod
            });
          });
          return [4
          /*yield*/
          , multicall.methods.aggregate(__spreadArray(__spreadArray(__spreadArray([], nameCalls, true), symbolCalls, true), decimalsCalls, true)).call()];

        case 2:
          callResult = _b.sent();
          _a = [0, 1, 2].map(function (index) {
            return callResult.returnData.slice(index * addresses_1["default"][network].length, (index + 1) * addresses_1["default"][network].length);
          }), encodedNames = _a[0], encodedSymbols = _a[1], encodedDecimals = _a[2];
          names = encodedNames.map(function (data) {
            return web3.eth.abi.decodeParameter('string', data);
          });
          symbols = encodedSymbols.map(function (data) {
            return web3.eth.abi.decodeParameter('string', data);
          });
          decimals = encodedDecimals.map(function (data) {
            return web3.eth.abi.decodeParameter('uint8', data);
          });
          return [4
          /*yield*/
          , web3.eth.getChainId()];

        case 3:
          chainId = _b.sent();
          return [2
          /*return*/
          , addresses_1["default"][network].map(function (address, index) {
            return {
              address: address,
              decimals: Number(decimals[index]),
              name: names[index],
              symbol: symbols[index],
              chainId: chainId
            };
          })];
      }
    });
  });
};

exports["default"] = getTokens;